export default {"src":"/_next/static/media/emptyFavorit.8ea857e6.svg","height":205,"width":240,"blurWidth":0,"blurHeight":0};